import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import { StoreProvider } from './context/StoreContext';
import Header from './components/site/Header';
import Footer from './components/site/Footer';
import CartDrawer from './components/site/CartDrawer';
import { Toaster } from './components/ui/toaster';
import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage';
import ProductPage from './pages/ProductPage';
import UnisexPage, { GenderPage } from './pages/GenderPage';
import BundlesPage from './pages/BundlesPage';
import LookbookPage from './pages/LookbookPage';
import GiftFinderPage from './pages/GiftFinderPage';
import AdminPage from './pages/AdminPage';
import { AboutPage, ContactPage, WishlistPage, AccountPage } from './pages/StaticPages';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: 'instant' }); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <StoreProvider>
          <ScrollToTop />
          <Header />
          <main className="min-h-[60vh]">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/shop" element={<ShopPage />} />
              <Route path="/product/:id" element={<ProductPage />} />
              <Route path="/men" element={<GenderPage gender="men" />} />
              <Route path="/women" element={<GenderPage gender="women" />} />
              <Route path="/unisex" element={<UnisexPage />} />
              <Route path="/bundles" element={<BundlesPage />} />
              <Route path="/lookbook" element={<LookbookPage />} />
              <Route path="/gift-finder" element={<GiftFinderPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/wishlist" element={<WishlistPage />} />
              <Route path="/account" element={<AccountPage />} />
            </Routes>
          </main>
          <Footer />
          <CartDrawer />
          <Toaster />
        </StoreProvider>
      </BrowserRouter>
    </div>
  );
}
